

















































import { PropType } from 'vue';
import { IUser } from '@/models/user';

import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';

const baseMixins = mixins(Proxyable);

export default baseMixins.extend({
  name: 'MentionMenuPopover',

  props: {
    target: {
      type: HTMLSpanElement,
      required: true
    },
    mention: {
      type: Object as PropType<IUser>,
      required: true
    }
  },

  watch: {
    internalValue(val: boolean) {
      if (!val) this.$emit('menu:close');
    }
  }
});
